module.exports = __webpack_public_path__ + "img/csr_032423_E.8dcf0822.jpg";